import { render } from "./AttractTable.vue?vue&type=template&id=10788500&scoped=true"
import script from "./AttractTable.vue?vue&type=script&lang=js"
export * from "./AttractTable.vue?vue&type=script&lang=js"

import "./AttractTable.vue?vue&type=style&index=0&id=10788500&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10788500"

export default script